export const SYS_CONCURRENCY_CONFLICT = 'Another user has modified this data submission, and the page has been refreshed with the current data. Please recheck this page as your data entry on this page may have been overwritten.' as const;
